import axios from "axios";
import {getOptions} from "../../helpers/api";

export const media = {

  uploadMedia: (data) => {
    const headers = {
      "X-Application-Bucket": data.bucket,
      "X-Application": "PDT",
      'Content-Type': 'application/x-www-form-urlencoded',
      "Authorization": `Bearer ${data.token}`
    };
    return axios.post('/mashhad.api/media', data.body, {headers});
  },

  downloadMedia: (data) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/media/${data.file.MediaReferenceId}/download`, { responseType: "blob", ...headers });
  }

}